import React from 'react'
import PropTypes from 'prop-types'
import { downloadPDF } from 'utils/misc'
import { Button } from 'components/UIElements'

import accountSetupFirstStep from '../../../../../../../../../assets/account-setup1.png'
import accountSetupSecondStep from '../../../../../../../../../assets/account-setup2.png'
import accountSetupThirdStep from '../../../../../../../../../assets/account-setup3.png'
import accountSetupFourthStep from '../../../../../../../../../assets/account-setup4.png'

import '../stylesheets/accountsetup.scss'

const illustrations = [
  {
    number: 1,
    imageSrc: accountSetupFirstStep,
    label: 'Schedule a call or a meeting with the participant to complete account setup.',
  },
  {
    number: 2,
    imageSrc: accountSetupSecondStep,
    label: 'At the time of the appointment or when the participant is ready to login, generate temporary password. ',
  },
  {
    number: 3,
    imageSrc: accountSetupThirdStep,
    label: 'Communicate the auto-generated username and password to the participant.',
  },
  {
    number: 4,
    imageSrc: accountSetupFourthStep,
    label:
      'Account setup is successful when the participant logs in for the first time. The temporary password will expire after 24hours.',
  },
]

const themes = {
  white: {
    color: '#000000',
    background: '#ffffff',
  },
  black: {
    color: '#ffffff',
    background: '#343334',
  },
}

const AccountSetup = ({ theme = 'white', title, url, fileName } = {}) => {
  const { color, background } = themes[theme]

  return (
    <div className={`account-setup account-setup-${theme}`} style={{ background }}>
      {title && (
        <h5 className='account-setup-title' style={{ color }}>
          {title}
        </h5>
      )}
      <p className='account-setup-text' style={{ color }}>
        This study does not collect any participant contact information. An admin will need to communicate with the
        participant outside of of Datacubed Health platform with registration information as follows:
      </p>
      <div className='flexed account-setup-illustrations'>
        {illustrations.map(({ number, imageSrc, label }) => (
          <div key={number} className='account-setup-illustration'>
            <div className='account-setup-illustration-number'>{number}</div>
            <img src={imageSrc} />
            <p className='account-setup-illustration-text text-align-center'>{label}</p>
          </div>
        ))}
      </div>
      <div className='flexed'>
        <div />
        <div className='account-setup-text flexed' style={{ color }}>
          {'Questions? Download '}
          <Button className='account-setup-u' link inline onClick={() => downloadPDF(url, fileName)}>
            <u>this guide.</u>
          </Button>
        </div>
      </div>
    </div>
  )
}

AccountSetup.propTypes = {
  theme: PropTypes.string,
  title: PropTypes.string,
}

export default AccountSetup
